// Filter chips for Metrics trait filters (also usable for any "source:
// value" filter whose values OR together server-side). Values picked for
// the SAME trait match ANY of them, so they render as ONE chip that reads
// "CPC Part #: AQG17006HT or AQG17008HT", each value with its own remove
// button. Different traits get separate chips (they AND).
//
//   renderTraitChips(host, filters, onRemove)
//     host      element to append chips to (NOT cleared; clear it first
//               when re-rendering)
//     filters   [{ traitId, label, value }, ...]; traitId groups the chips,
//               label is the trait's display name. Extra keys are ignored
//               and the objects are passed back untouched.
//     onRemove  (filter, index) => void, index into `filters`
//
//   groupTraitFilters(filters) -> [{ traitId, label, items: [{ filter, index }] }]
//     same grouping without rendering (first-seen order), e.g. for summaries.
//
//   describeTraitFilters(filters) -> 'CPC Part #: A or B · Color: Red'
//
// Markup: span.m-chip (plus .m-chip-any when it holds several values)
// > span label, then strong value + button per value, joined by
// span.m-chip-or. Styles in metrics.scss (.m-chip, .m-chip-or).

export function groupTraitFilters(filters) {
  const groups = []
  const byId = new Map()
  filters.forEach((filter, index) => {
    const id = String(filter.traitId)
    let group = byId.get(id)
    if (!group) {
      group = { traitId: id, label: filter.label || id, items: [] }
      byId.set(id, group)
      groups.push(group)
    }
    group.items.push({ filter, index })
  })
  return groups
}

export function describeTraitFilters(filters) {
  return groupTraitFilters(filters)
    .map(g => `${g.label}: ${g.items.map(i => i.filter.value).join(' or ')}`)
    .join(' · ')
}

export function renderTraitChips(host, filters, onRemove) {
  groupTraitFilters(filters).forEach((group) => {
    const chip = document.createElement('span')
    chip.className = group.items.length > 1 ? 'm-chip m-chip-any' : 'm-chip'
    if (group.items.length > 1) chip.title = `Matches any of these ${group.label} values`
    const label = document.createElement('span')
    label.textContent = `${group.label}: `
    chip.appendChild(label)
    group.items.forEach(({ filter, index }, i) => {
      if (i > 0) {
        const or = document.createElement('span')
        or.className = 'm-chip-or'
        or.textContent = 'or'
        chip.appendChild(or)
      }
      const strong = document.createElement('strong')
      strong.textContent = filter.value
      chip.appendChild(strong)
      const x = document.createElement('button')
      x.type = 'button'
      x.textContent = '✕'
      x.title = `Remove ${filter.value}`
      x.addEventListener('click', () => onRemove(filter, index))
      chip.appendChild(x)
    })
    host.appendChild(chip)
  })
}
